import { css, cx } from '@linaria/core';
import { flex } from 'styles/utils';
const SubtitleStyle = "omponents__UploadArea__components__Subtitle__Subtitle_styles_ts-SubtitleStyle-s1tfeyyp";
export const SubtitleStyles = cx(flex.init, flex.direction.row, SubtitleStyle);
const hoverTextStyle = "omponents__UploadArea__components__Subtitle__Subtitle_styles_ts-hoverTextStyle-h10679st";
export const hoverTextStyles = cx(hoverTextStyle);
const popoverTextStyle = "omponents__UploadArea__components__Subtitle__Subtitle_styles_ts-popoverTextStyle-pazwysn";
export const popoverTextStyles = cx(popoverTextStyle);
const popoverContainerStyle = "omponents__UploadArea__components__Subtitle__Subtitle_styles_ts-popoverContainerStyle-pbulzp6";
export const popoverContainerStyles = cx(popoverContainerStyle);

require("./Subtitle.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Subtitle.styles.ts");